import { render, staticRenderFns } from "./agreement_update.vue?vue&type=template&id=d59d5da4"
import script from "./agreement_update.vue?vue&type=script&lang=js"
export * from "./agreement_update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports